import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from "react-redux";
import {usersActions} from "../../modules/users/users.actions";
import Loader from "./layout/loading/loader";
import {Formik, isString} from "formik";
import './UsersNewOrEdit.css'
import {object, string} from 'yup';
import {Container} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {useParams} from "react-router-dom";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import SubmitButton from "./layout/forms/SubmitButton";
import {laveusesActions} from "../../modules/laveuses/laveuses.actions";
import LaveuseDataField from "./laveuse/form/LaveuseDataField";
import {LocalShipping} from "@mui/icons-material";
import PageTitle from "./layout/PageTitle";


const laveuseValidationSchema = object({
    immatriculation: string()
        .required("L'immatriculation est requise")
        .max(255, 'Le libellé ne doit pas dépasser 255 caractères'),
});


function LaveusesNewOrEdit({...props}) {
    const dispatch = useDispatch();
    const params = useParams();
    const [mode, setMode] = useState("create");
    const [laveuseId, setLaveuseId] = useState(null);

    useEffect(() => {
        if (params.hasOwnProperty("id")) {
            setMode("edit");
            setLaveuseId(params.id);
        } else {
            setMode("create");
            setLaveuseId(null);
        }
    }, [params]);

    useEffect(() => {
        if (laveuseId && (props.laveuse?.id !== parseInt(laveuseId)) && !props.loading && !props.error) {
            dispatch(laveusesActions.fetchLaveuse(laveuseId));
        }
    }, [props, dispatch, laveuseId]);

    useEffect(() => {
        if (!props.users && !props.loading && !props.error) {
            dispatch(usersActions.fetchUsers());
        }
    }, [dispatch, props.users, props.error, props.loading]);

    const getOperateurs = () => {
        if (props.users) {
            // On récupère les opérateurs de l'exploitant connecté
            return props.users[0]?.operateurs
        }
        return []
    }

    const initialValues = {
        id: props.laveuse?.id ?? null,
        immatriculation: props.laveuse?.immatriculation || '',
        description: props.laveuse?.description || '',
        telemetryProvider: props.laveuse?.telemetryProvider || '',
        telemetryExternalId: props.laveuse?.telemetryExternalId || '',
        emissionCo2: props.laveuse?.emissionCo2 || 0,
        operateur: props.laveuse?.operateur?.["@id"] || ''
    };

    const handleSubmit = (values) => {
        // Nettoyage des champs télématique
        if (!values.telemetryProvider) {
            delete values.telemetryProvider;
        }
        if (!values.telemetryExternalId) {
            delete values.telemetryExternalId;
        }

        if (isString(values.emissionCo2)) {
            values.emissionCo2 = parseInt(values.emissionCo2)
        }

        if (values.operateur === "") {
            delete values.operateur
        }
        if (mode === "create") {
            dispatch(laveusesActions.createLaveuse(values));
        } else {
            dispatch(laveusesActions.updateLaveuse(values));
        }
    }


    if (props.loading) {
        return <Loader/>;
    }

    return (
        <>
            <PageTitle title={mode === "create" ? "Nouvelle laveuse" : "Modifier la laveuse"} icon={<LocalShipping/>}/>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={laveuseValidationSchema}
                onSubmit={(values, {setSubmitting}) => {
                    handleSubmit(values)
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      /* and other goodies */
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <LaveuseDataField values={values} errors={errors} handleChange={handleChange}
                                          operateurs={getOperateurs()}
                                          handleBlur={handleBlur}/>

                        <Grid container size={12} justifyContent="center" style={{marginTop: '2rem'}}>
                            <Grid size={4}>
                                <SubmitButton submitting={isSubmitting && !props.error}/>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </Formik>
        </>
    )
}

const mapStateToProps = function (state) {
    return {
        laveuse: state.laveuses.laveuse,
        users: state.users.users,
        loading: state.laveuses.loading || state.users.loading,
        error: state.laveuses.error
    }
}

export default connect(mapStateToProps)(LaveusesNewOrEdit);
